import React, { useState, useEffect } from 'react'
import axios from "axios";
import { showToast } from './Toast';
import { getUserDetails } from "../Utility/AsyncStorage"
// import { CircularProgressbar } from 'react-circular-progressbar';
import Speedometer, {
  Background,
  Arc,
  Needle,
  Progress,
  Marks,
  DangerPath,
  Indicator,
} from 'react-speedometer';
import "../Styles/CircularBar.css"
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import versions from './version';
import { useNavigate } from "react-router-dom";

import "../Styles/Dashboard.css"

function Dashboard() {

  const navigate = useNavigate();
  const [statsData, setStatsData] = useState([])
  const [worstemp, setWorstemp] = useState([])
  const [worstmach, setWorstmach] = useState([])
  const [machinehaltList, setMachinehaltList] = useState([])
  const [wgCount, setWgCount] = useState([])
  const [timeLeft, setTimeLeft] = useState(45);

  var userDetails = getUserDetails();
  const today = new Date().toISOString().split('T')[0];

  const lastVersion = versions[versions.length - 1];


  const dashboardData = async () => {
    try {
      let url = process.env.REACT_APP_BASE_URL + "/ws/wsDashboard";
      let body = {
        comp_num: userDetails.comp_num
      }

      await axios.post(url, body, {
        headers: {
          'authorization': `${userDetails.access_token}`
        },
      }).then(response => {

        if (response.status === 200) {

          if (response.data.statusCode === 0) {

            // console.log("statsData", response.data.count)
            setStatsData(response.data.count)
          }
          else {
            console.log("statsData", response.data.msg)
          }

        }
        else if (response.status === 403) {

          navigate("/")

        } else {
          showToast(response.data.msg, 3000, "red");
        }

      }).catch(error => {
        console.log("statsData", error)
      })
    } catch (error) {
      console.log("statsData", error)
    }
  }

  const worstempList = async () => {
    try {
      let url = process.env.REACT_APP_BASE_URL + "/emp/fetchEmpEfficencyWiseList";
      let body = {
        cDate: today
      }

      await axios.post(url, body, {
        headers: {
          'authorization': `${userDetails.access_token}`
        },
      }).then(response => {

        if (response.status === 200) {

          if (response.data.statusCode === 0) {

            // console.log("worstempList", response.data.list)
            setWorstemp(response.data.list.slice(0, 10))
          }
          else {
            console.log("worstempList", response.data.msg)
          }

        }

      }).catch(error => {
        console.log("worstempList", error)
      })
    } catch (error) {
      console.log("worstempList", error)
    }
  }

  const worstmachList = async () => {
    try {
      let url = process.env.REACT_APP_BASE_URL + "/sensor/iffMachineList";
      let body = {
        comp_num: userDetails.comp_num
      }

      await axios.post(url, body, {
        headers: {
          'authorization': `${userDetails.access_token}`
        },
      }).then(response => {

        if (response.status === 200) {

          if (response.data.statusCode === 0) {

            // console.log("worstmach", response.data.result)
            setWorstmach(response.data.result.slice(0, 9))
          }
          else {
            console.log("worstmach", response.data.msg)
          }

        }

      }).catch(error => {
        console.log("worstmach", error)
      })
    } catch (error) {
      console.log("worstmach", error)
    }
  }

  const machineHalt = async () => {
    try {
      let url = process.env.REACT_APP_BASE_URL + "/emp/fetchEmpMachineHalt";
      let body = {
        cDate: today
      }

      await axios.post(url, body, {
        headers: {
          'authorization': `${userDetails.access_token}`
        },
      }).then(response => {

        if (response.status === 200) {

          if (response.data.statusCode === 0) {

            // console.log("machineHalt", response.data.list)
            setMachinehaltList(response.data.list.slice(0, 10))
          }
          else {
            console.log("machineHalt", response.data.msg)
          }

        }

      }).catch(error => {
        console.log("machineHalt", error)
      })
    } catch (error) {
      console.log("machineHalt", error)
    }
  }

  const worstwg = async () => {
    try {
      let url = process.env.REACT_APP_BASE_URL + "/wg/wgListWorst";
      let body = {
        comp_num: userDetails.comp_num
      }

      await axios.post(url, body, {
        headers: {
          'authorization': `${userDetails.access_token}`
        },
      }).then(response => {

        if (response.status === 200) {

          if (response.data.statusCode === 0) {

            // console.log("worstwg", response.data.new_data)
            setWgCount(response.data.new_data)
          }
          else {
            console.log("worstwg", response.data.msg)
          }

        }

      }).catch(error => {
        console.log("worstwg", error)
      })
    } catch (error) {
      console.log("worstwg", error)
    }
  }


  useEffect(() => {
    dashboardData();
    worstempList();
    worstmachList();
    machineHalt();
    worstwg();
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev === 1) {
          onTimerComplete();
          return 45;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const onTimerComplete = () => {
    console.log("Timer completed!");
    setTimeLeft(45)
    dashboardData();
    worstempList();
    worstmachList();
    machineHalt();
    worstwg();
  };

  return (
    <div>
      <div style={{
        backgroundColor: '#f8f9fa',
        borderBottom: "2px solid #e0e0e0", display: 'inline-flex', width: "100%", alignItems: 'center', justifyContent: "space-between"
      }}>
        <h2 className="header-h2" style={{ textAlign: "left", color: '#202a66', marginLeft: 50, padding: "10px 0" }}> IFF Overseas</h2>

        {/* <i class="fa fa-sign-out"  style={{ marginRight: 10}}></i> */}
      </div>
      <div className='mainBlock'>



        <h4 style={{ position: "fixed", right: "50px", top: "20px", fontFamily: "Poppins,serif", fontWeight: "600", color: "red" }}
          onClick={() => onTimerComplete()}>00:{timeLeft} </h4>

        <div className="cardsBlock">

          <div className="card"  >
            <h1 className="cardText">{statsData.live_emp ?? 0}</h1>
            <h2 className="card-title">Live Employees</h2>
          </div>

          <div className="card"  >
            <h1 className="cardText">{statsData.live_machines ?? 0}</h1>
            <h2 className="card-title">Live Machines</h2>
          </div>

          <div className="card"  >
            <h1 className="cardText">{statsData.avg_worktime ?? 0}</h1>
            <h2 className="card-title">Average Worktime</h2>
          </div>

          <div className="card"  >
            <h1 className="cardText">{statsData.total_production ?? 0}</h1>
            <h2 className="card-title">Total Production</h2>
          </div>

        </div>


        <div className='inline' style={{ width: "95%", margin: "1% 2.5% 0 2.5%", }}>
          <div style={{ width: "45%", backgroundColor: "#f9f9f9", padding: "10px", borderRadius: "20px", height: "260px", boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)" }}>
            <h2 className='card_heading'>Employees</h2>

            {Object.keys(statsData).length === 0 ?

              <Skeleton count={5} />
              :
              <div>
                <div className='inline' style={{ alignItems: "center", justifyContent: "space-evenly" }}>
                  <div style={{ alignItems: "center", justifyContent: "space-around" }}>
                    {/* <div style={{ height: 50, display: "flex" }}>
                  <CircularProgressbar value={statsData.speedometer_emp_att.present_emp} text={`${((statsData.speedometer_emp_att.present_emp / statsData.speedometer_emp_att.total_emp) * 100).toFixed(0)}%`} maxValue={statsData.speedometer_emp_att.total_emp} minValue={0} />
                </div> */}
                    <div style={{ height: "62px" }}>
                      <Speedometer
                        width={100}
                        value={statsData.speedometer_emp_att.present_emp}
                        max={statsData.speedometer_emp_att.total_emp}
                        angle={230}
                        fontFamily='poppins'
                        color='red'
                      >
                        <DangerPath arcWidth={5} offset={-2} angle={230 - ((statsData.speedometer_emp_att.present_emp / statsData.speedometer_emp_att.total_emp) * 230)} />
                        <Background angle={230} color='transparent' />
                        <Arc arcWidth={5} />
                        <Needle circleRadius={4} color='black' circleColor="black" baseWidth={2} baseOffset={10} />
                        <Progress arcWidth={5} color="green" />
                        <Marks fontSize={14} lineSize={5} lineColor="green" color="#3d488c" />
                        <Indicator color='#3d488c' fontFamily='poppins' fontSize={26} />
                      </Speedometer>
                    </div>
                    <h4 className='sub-heading' style={{ marginTop: '20px' }}>Active</h4>
                  </div>

                  <div style={{ alignItems: "center", justifyContent: "space-around" }}>
                    {/* <div style={{ height: 50, display: "flex" }}>
                  <CircularProgressbar value={statsData.speedometer_emp_performance.present_work_hour} text={`${((statsData.speedometer_emp_performance.present_work_hour / statsData.speedometer_emp_performance.total_work_hour) * 100).toFixed(0)}%`} maxValue={statsData.speedometer_emp_performance.total_work_hour} />
                </div> */}
                    <div style={{ height: "62px" }}>
                      <Speedometer
                        width={100}
                        value={statsData.speedometer_emp_performance.present_work_hour}
                        max={statsData.speedometer_emp_performance.total_work_hour}
                        angle={230}
                        fontFamily='poppins'
                        color='#7c7c7c'
                      >
                        <DangerPath arcWidth={5} offset={-2} angle={230 - ((statsData.speedometer_emp_performance.present_work_hour / statsData.speedometer_emp_performance.total_work_hour) * 230)} />
                        <Background angle={230} color='transparent' />
                        <Arc arcWidth={5} />
                        <Needle circleRadius={4} color='black' circleColor="black" baseWidth={2} baseOffset={10} />
                        <Progress arcWidth={5} color="green" />
                        <Marks fontSize={14} lineSize={5} lineColor="green" color="#3d488c" step={50} />
                        <Indicator color='#3d488c' fontFamily='poppins' fontSize={26} />
                      </Speedometer>
                    </div>
                    <h4 className='sub-heading' style={{ marginTop: '20px' }}>performance(in hrs)</h4>
                  </div>
                </div>

                <div style={{ height: "120px", overflowY: "scroll", scrollbarWidth: "none" }}>
                  <table className='emp-table'>
                    <thead style={{ borderRadius: "10px", backgroundColor: "#ddd", position: "sticky", top: 0, zIndex: 1 }}>
                      {/* <tr> */}
                      <th style={{ borderRadius: "8px 0 0 8px" }}>Name</th>
                      <th>Run time</th>
                      <th>Efficiency (in hrs)</th>
                      <th style={{ borderRadius: "0 8px 8px 0" }}>Best eff</th>
                      {/* </tr> */}
                    </thead>
                    <tbody>
                      {worstemp.map((item, index) => (
                        <tr key={index}>
                          <td style={{ borderRadius: "5px 0 0 5px" }}>{item.emp_name}</td>
                          <td>{item.total_working_time}</td>
                          <td>{item.efficiency_in_hours}</td>
                          <td style={{ borderRadius: "0 5px 5px 0" }}>{item.best_eff}%</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            }
          </div>

          <div style={{ width: "45%", backgroundColor: "#f9f9f9", padding: "10px", borderRadius: "20px", height: "260px", boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)" }}>
            <h2 className='card_heading'>Machines</h2>
            {Object.keys(statsData).length === 0 ?
              <Skeleton count={5} />
              :
              <div>
                <div className='inline' style={{ alignItems: "center", justifyContent: "space-evenly" }}>
                  <div style={{ alignItems: "center", justifyContent: "space-around" }}>
                    {/* <div style={{ height: 50, display: "flex" }}>
                  <CircularProgressbar value={statsData.speedometer_mc_att.active_mc} text={`${((statsData.speedometer_mc_att.active_mc / statsData.speedometer_mc_att.total_mc) * 100).toFixed(0)}%`} maxValue={statsData.speedometer_mc_att.total_mc} />
                </div> */}
                    <div style={{ height: "62px" }}>
                      <Speedometer
                        width={100}
                        value={statsData.speedometer_mc_att.active_mc}
                        max={statsData.speedometer_mc_att.total_mc}
                        angle={230}
                        fontFamily='poppins'
                        color='#7c7c7c'
                      >
                        <DangerPath arcWidth={5} offset={-2} angle={230 - ((statsData.speedometer_mc_att.active_mc / statsData.speedometer_mc_att.total_mc) * 230)} />
                        <Background angle={230} color='transparent' />
                        <Arc arcWidth={5} />
                        <Needle circleRadius={4} color='black' circleColor="black" baseWidth={2} baseOffset={10} />
                        <Progress arcWidth={5} color="green" />
                        <Marks fontSize={14} lineSize={5} lineColor="green" color="#3d488c" />
                        <Indicator color='#3d488c' fontFamily='poppins' fontSize={26} />
                      </Speedometer>
                    </div>
                    <h4 className='sub-heading' style={{ marginTop: "20px" }}>Active</h4>
                  </div>
                  <div style={{ alignItems: "center", justifyContent: "space-evenly" }}>
                    {/* <div style={{ height: 50, display: "flex" }}>
                  <CircularProgressbar value={statsData.speedometer_mc_eff.present_mc_eff} text={`${statsData.speedometer_mc_eff.total_mc_eff ? ((statsData.speedometer_mc_eff.present_mc_eff / statsData.speedometer_mc_eff.total_mc_eff) * 100).toFixed(0) : 0}%`} maxValue={statsData.speedometer_mc_eff.total_mc_eff} />
                </div> */}

                    <div style={{ height: "62px" }}>
                      <Speedometer
                        width={100}
                        value={statsData.speedometer_mc_eff.present_mc_eff}
                        max={(statsData.speedometer_mc_eff.total_mc_eff !== 0 ? statsData.speedometer_mc_eff.total_mc_eff : 50)}
                        angle={230}
                        fontFamily='poppins'
                        color='#7c7c7c'
                      >
                        <DangerPath arcWidth={5} offset={-2} angle={230 - ((statsData.speedometer_mc_eff.present_mc_eff / (statsData.speedometer_mc_eff.total_mc_eff !== 0 ? statsData.speedometer_mc_eff.total_mc_eff : 1)) * 230)} />
                        <Background angle={230} color='transparent' />
                        <Arc arcWidth={5} />
                        <Needle circleRadius={4} color='black' circleColor="black" baseWidth={2} baseOffset={10} />
                        <Progress arcWidth={5} color="green" />
                        <Marks fontSize={14} lineSize={5} lineColor="green" color="#3d488c" />
                        <Indicator color='#3d488c' fontFamily='poppins' fontSize={26} />
                      </Speedometer>
                    </div>

                    <h4 style={{ textAlign: "center", marginTop: "20px" }} className='sub-heading'>Performance (in hrs)</h4>
                  </div>
                </div>

                <div style={{ height: "120px", overflowY: "scroll", scrollbarWidth: "none" }}>
                  <table className='emp-table'>
                    <thead style={{ borderRadius: "10px", backgroundColor: "#ddd" }}>
                      {/* <tr> */}
                      <th style={{ borderRadius: "8px 0 0 8px" }}>Employees</th>
                      <th>Machine</th>
                      <th>Efficiency (in hrs)</th>
                      <th style={{ borderRadius: "0 8px 8px 0" }}>Best eff</th>
                      {/* </tr> */}
                    </thead>
                    <tbody>
                      {worstmach.map((item, index) => (
                        <tr key={index}>
                          <td style={{ borderRadius: "5px 0 0 5px" }}>{item.employee_name}</td>
                          <td>{item.machine_name}</td>
                          <td>{item.efficiency ?? 0}</td>
                          <td style={{ borderRadius: "0 5px 5px 0" }}>{item.best_eff}%</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            }
            <div>

            </div>
          </div>
        </div>

        <div className='inline' style={{ width: "95%", margin: "2% 2.5% 0 2.5%", }} >
          <div style={{ width: "45%", backgroundColor: "#f9f9f9", padding: "10px", borderRadius: "20px", height: "190px", boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)" }}>
            <h2 className='card_heading'>Work Groups</h2>
            <div style={{ height: "150px", overflowY: "scroll", scrollbarWidth: "none" }}>
              <table className='emp-table'>
                <thead style={{ borderRadius: "10px", backgroundColor: "#ddd" }}>
                  {/* <tr> */}
                  <th style={{ borderRadius: "8px 0 0 8px" }}>Name</th>
                  <th>Production</th>
                  <th>Machine Halts</th>
                  <th>Target</th>
                  <th style={{ borderRadius: "0 8px 8px 0" }}>Picked up</th>
                  {/* </tr> */}
                </thead>
                <tbody>
                  {wgCount.map((item, index) => (
                    <tr key={index}>
                      <td style={{ borderRadius: "5px 0 0 5px" }}>{item.wg_name}</td>
                      <td>{item.current_job_working}</td>
                      <td>{item.machine_halt_count}</td>
                      <td> {item.line_target}</td>
                      <td style={{ borderRadius: "0 5px 5px 0" }}>{item.collect_from_ws}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div style={{ width: "45%", backgroundColor: "#f9f9f9", padding: "10px", borderRadius: "20px", height: "190px", boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)" }}>
            <h2 className='card_heading'>Employees Halts</h2>
            {Object.keys(machinehaltList).length === 0 ? <h2 className='card_heading' style={{ color: "red", marginTop: "50px" }}>No data found</h2> :
              <div style={{ height: "150px", overflowY: "scroll", scrollbarWidth: "none" }}>
                <table className='emp-table'>
                  <thead style={{ borderRadius: "10px", backgroundColor: "#ddd" }}>
                    {/* <tr> */}
                    <th style={{ borderRadius: "8px 0 0 8px" }}>Employee</th>
                    <th>Machine</th>
                    <th>From</th>
                    <th>To</th>
                    <th style={{ borderRadius: "0 8px 8px 0" }}>Duration</th>
                    {/* </tr> */}
                  </thead>
                  <tbody>
                    {machinehaltList.map((item, index) => (
                      <tr key={index}>
                        <td style={{ borderRadius: "5px 0 0 5px" }}>{item.emp_name}</td>
                        <td>{item.machine_name}</td>
                        <td>{item.start_time.slice(11, 19)}</td>
                        <td>{item.end_time.slice(11, 19)}</td>
                        <td style={{ borderRadius: "0 5px 5px 0" }}>{item.halt_duration}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            }

          </div>
        </div>

        <h5 className='versionupdate'>Version {lastVersion.version}</h5>
      </div>
      <div className='powered'>
        <i class="fa fa-copyright" style={{ fontSize: 10, paddingRight: 4 }}></i>
        <p>Powered by</p>
        <img style={{ width: "20px", margin: "0  0 0 5px" }}
          src={require("../Assets/new_logo.png")}
          alt="logo"
        />
        <p style={{ margin: 0, fontWeight: 600 }}>SuperManager</p>
      </div>
    </div>
  )
}

export default Dashboard